"use client";

import styles from "./WelcomeBanner.module.scss";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { Link } from "@/i18n/navigation";

export default function WelcomeBanner() {
  const t = useTranslations("BannerMain");

  return (
    <div className={styles.banner}>
      <div className={styles.wrapper}>
        <Image
          className={styles.wrapper_image}
          src="/images/banners/fs.png"
          width={500}
          height={500}
          quality={100}
          alt="banner"
          priority
        />
        <div className={styles.desc}>
          <div className={styles.desc_title}>{t("title")}</div>
          <div className={styles.desc_bonus}>
            <mark>+100%</mark> {t("bonus")}
          </div>
          {/* <div className={styles.desc_subtitle}>
              {t("subtitle")}{" "}
              <Link href={"/game/belatra/mummyland-treasures"}>Mummyland Treasures</Link>
            </div> */}
          <Link href={"/promotions"} className={styles.desc_button}>
            {t("button")}
            <svg
              viewBox="0 0 17 12"
              fill="currentColor"
              width="18"
              height="100%"
              className={styles.button__icon}
            >
              <use href="/images/sprite.svg#arrow-2-right"></use>
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
}
